/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { Styles } from './style';
import { useNavigate } from 'react-router-dom';
import { usePropertyStore } from '@stores/Property/Property';
import { IProperty } from '@stores/Property/types';

const Carousel = () => {
  const { fetchFeaturedProperties } = usePropertyStore();
  const [properties, setProperties] = useState<IProperty[]>([]);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    if (properties.length === 0) {
      return;
    }
    setCurrentIndex((prevIndex) => (prevIndex + 1) % properties.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + properties.length) % properties.length
    );
  };

  useEffect(() => {
    if (properties.length === 0) {
      return;
    }
    const intervalId = setInterval(nextSlide, 5000);

    return () => clearInterval(intervalId);
  }, [properties]);

  const handlePropertyClick = () => {
    navigate(`/imoveis/${properties[currentIndex].id}`);
  };

  useEffect(() => {
    const loadFeaturedProperties = async () => {
      const featuredProperties = await fetchFeaturedProperties();
      setProperties(featuredProperties);
    };
    loadFeaturedProperties();
  }, [fetchFeaturedProperties]);

  if (properties.length === 0) {
    return <Styles.CarouselContainer />;
  }

  const current = properties[currentIndex];
  const codigo =
    (typeof current.cod_imovel === 'string'
      ? current.cod_imovel
      : current.cod_imovel?.cod) + current.id;

  return (
    <Styles.CarouselContainer>
      <Styles.Slide
        onClick={handlePropertyClick}
        backgroundImage={current.foto_capa}
        style={{ cursor: 'pointer' }}
      />
      <Styles.Arrow direction="left" onClick={prevSlide}>
        ◄
      </Styles.Arrow>
      <Styles.Arrow direction="right" onClick={nextSlide}>
        ►
      </Styles.Arrow>

      {codigo && (
        <Styles.OverlayButton>
          {`${current.titulo} Código: ${codigo}`}
        </Styles.OverlayButton>
      )}
    </Styles.CarouselContainer>
  );
};

export default Carousel;
